import { useMemoizedFn, useSafeState } from 'ahooks';

const useCopyToClipboard = () => {
  const [copiedText, setCopiedText] = useSafeState<string | null>(null);

  const copyToClipboard = useMemoizedFn(async (text: string) => {
    if (!navigator?.clipboard) {
      console.warn('کلیپبورد پشتیبانی نمی شود.');

      // Fallback for older browsers
      try {
        const textArea = document.createElement('textarea');
        textArea.value = text;
        textArea.style.position = 'fixed';
        textArea.style.opacity = '0';
        document.body.appendChild(textArea);
        textArea.select();

        const successful = document.execCommand('copy');
        document.body.removeChild(textArea);

        if (successful) {
          setCopiedText(text);
          return true;
        }
        return false;
      } catch (fallbackError) {
        console.warn('Fallback copy failed: ', fallbackError);
        return false;
      }
    }

    // Try to save to clipboard then save it in the state if worked
    try {
      await navigator.clipboard.writeText(text);
      setCopiedText(text);
      return true;
    } catch (error) {
      console.warn('خطا در کپی گرفتن: ', error);
      setCopiedText(null);
      return false;
    }
  });

  return { copiedText, copyToClipboard };
};

export { useCopyToClipboard };
